
import { Component, Vue } from 'vue-property-decorator'
import { RoleClient } from '@/api'
import { IRoleData } from '@/api/types'
import RoleEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'

@Component({
  name: 'RoleList',
  components: {
    RoleEditor
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new RoleClient()
    this.listQuery = {
      filter: {
        where: { name: { like: '' } },
        fields: {
          id: true,
          name: true,
          description: true,
          permission_list: true,
          createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt']
      }
    }
  }

  async created() {
    super.created()
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.name.like = `%${this.listQuery.filter.where.name.like}%`
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: IRoleData) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: IRoleData) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }
}
